import cloneDeep from 'lodash/cloneDeep';
import { SetAllPoints } from '../points.actions';
import { TPointsByWorkspace } from '../points.model';
import { preserveLoadedDetailFields } from './preserve-detail-fields';

export function setAllPoints(
  oldState: TPointsByWorkspace,
  action: SetAllPoints,
): TPointsByWorkspace {
  const state = cloneDeep(oldState);

  Object.keys(action.payload.pointsByWorkspace).forEach((workspaceId) => {
    if (!state[workspaceId]) {
      state[workspaceId] = {};
    }

    state[workspaceId].entities = preserveLoadedDetailFields(
      state[workspaceId].entities,
      action.payload.pointsByWorkspace[workspaceId],
    );
  });

  return state;
}
